import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BDCDocument } from '../models/BDCDocument';

@Injectable({
    providedIn: 'root',
})
export class DocumentsService {
    constructor(private http: HttpClient) {}

    getTeachingSheets(): Observable<BDCDocument[]> {
        const url = `/api/v1/documents/?name=fiche_`;

        return this.http.get<BDCDocument[]>(url);
    }
}
